import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';

import { TimePickerComponent } from './time-picker.component';
import { TranslocoSelectDirectiveModule } from 'src/app/directives/transloco-select/transloco-select.module';
import { MealDeliveryAreaTimingDisplayPipe } from './MealDeliveryAreaTimingDisplay-pipe';

@NgModule({
  declarations: [TimePickerComponent, MealDeliveryAreaTimingDisplayPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslocoModule,
    TranslocoSelectDirectiveModule
  ],
  exports: [TimePickerComponent]
})
export class TimePickerComponentModule {}
